export default class ListUtils {
    static move(old_array, old_index, new_index) {
        const result = old_array.map((item, index, array) => {
            if (index === old_index) {
                const element = array[new_index];
                return element;
            } else if (index === new_index) {
                const element = array[old_index];
                return element;
            } else {
                return item;
            }
        });
        return result;
    }
}
